module.exports = __webpack_public_path__ + "img/mobile/Background/intro_background_portrait@1x.jpg?1.0.17";